import React from "react";
import { Link } from "react-router-dom";
import SVG from "../core/SVG";
import ToolTipV2 from "../core/ToolTipV2";
import { logo, postKey } from "utils/assets_exports/images";

const TreandingPageHeader = () => {
    return (
        <div className="d-flex flex-j-between flex-a-center gap-10 w-full text-center mb-30 mt-20">
            <div style={{ width: "90px" }}>
                <Link to="/">
                    <SVG svg="chevron-left" size={24} />
                </Link>
            </div>
            <h1 className="fw-700 fs-12em">Trending</h1>

            <div className="trending-imgs d-flex gap-10">
                <ToolTipV2 text="posts">
                    <Link to="/trending">
                        <img src={postKey} alt="posts" />
                    </Link>
                </ToolTipV2>
                <ToolTipV2 text="incidents">
                    <Link to="/trending/incidents">
                        <img src={logo} alt="incidents" />
                    </Link>
                </ToolTipV2>
            </div>
        </div>
    );
};

export default TreandingPageHeader;
